module.exports = __webpack_public_path__ + "static/go-burguer-bancada-sanduiches-molho-bg-2be8756005699e67418ea05c2b58b9bf.jpg";